import { fetchGet, fetchDelete, fetchPost } from './fetch';

const API_URL = '/api/v1/audio';

export enum UpdateFileTypeEnum {
  record = 'record',
  track = 'track',
}

export type UploadForAcrResponseDTO = {
  data?: {
    id: number;
    name: string;
    filePath: string;
    type?: UpdateFileTypeEnum;
  };
  error?: {
    errorMessage: string;
    code: number;
  };
};

export type HummingAudioType = {
  id: number;
  name: string;
  status: string;
  url: string;
  created_at: string;
  metadata?: {
    duration?: number;
  };
};

export const postAudioUploadForAcr = async (req: FormData): Promise<UploadForAcrResponseDTO> => {
  const url = `/api/v2/audio/upload_audio_for_acr`;
  return fetchPost<FormData, UploadForAcrResponseDTO>(url, req);
};

export const getAudioAcrStatus = async (
  id: number,
): Promise<{
  data: { status: 'checking' | 'error' | 'success' | 'updating' };
}> => {
  const url = `${API_URL}/acr_status/${id}`;
  return fetchGet<{
    data: { status: 'checking' | 'error' | 'success' | 'updating' };
  }>(url);
};

export const getHummingAudio = async (): Promise<{
  data: HummingAudioType[];
}> => {
  const url = `${API_URL}/humming_audio`;
  return fetchGet<{ data: HummingAudioType[] }>(url);
};

export const deleteUploadedFile = async (id: number): Promise<{ data: object }> => {
  const url = `${API_URL}/delete_uploaded_file/${id}`;
  return fetchDelete<object, { data: object }>(url);
};
